import { useEffect, useState } from 'react'

// NOTE: This hook is not specifically unit tested due a lack of ability in jsdom

/**
 * Match against a provided media query that updates every time the MediaQueryListEvent triggers
 * @param query Media query to match
 * @returns A value indicating whether this media query is matched, or not
 */
export const useMediaQuery = (query: string, windowObject?: any) => {
  const [matches, setMatches] = useState<boolean>(
    () => (windowObject || window)?.matchMedia(query)?.matches || false,
  )

  useEffect(() => {
    const mql = (windowObject || window).matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    if (mql.matches) {
      setMatches(true)
    }

    mql.addEventListener('change', onChange)

    return () => {
      mql.removeEventListener('change', onChange)
    }
  }, [query, windowObject])

  return matches
}
